export default function($element, wizard, params = {}) {
  this.$element = $element
  this.params = params
  this.wizard = wizard

  this.steps = []
  this.currentStep = 0
  this.firstVisibleStep = this.params.numVisible
  this.panels = this.params.pages || []

  this.resizeSteps = () => {
    this.steps.forEach($step => $step.css('width', this.getItemWidth()))
  }

  this.buildMenu = () => {
    const $holder = $(JST['templates/wizard-nav']())

    this.$element.html($holder)

    this.$prev = $('.js-wizardNav_prev')
    this.$next = $('.js-wizardNav_next')

    this.$stepHolder = $('#js-wizardNav_stepHolder', $holder)

    this.panels.forEach((panel, i) => {
      const $el = $(JST['templates/wizard-nav-item']({
        title: panel.name,
        icon: panel.icon,
        number: i + 1,
        step: I18n.t('dict.step'),
      }))

      this.addStepClickEvent($el)
      this.$stepHolder.append($el)
      this.steps.push($el)
    })

    this.positionNav()
  }

  this.setTabIndex = () => {
    this.steps.forEach((step, i) => {
      step.find('a').attr('tabindex', this.getIndexNum(i))
    })
  }

  this.getIndexNum = i => (i >= this.indexStart() && i <= this.indexEnd()) ? '' : '-1'

  this.indexStart = () => Math.max(this.indexPos(), 0)

  this.indexEnd = () => this.indexStart() + this.firstVisibleStep - 1

  this.getNavLeftPos = () => Math.min(-this.indexPos() * this.getItemWidth(), 0)

  this.indexPos = () => {
    return Math.min(
      this.currentStep - (Math.round(this.firstVisibleStep / 2) - 1),
      this.totalSteps() - this.firstVisibleStep
    )
  }

  this.getItemWidth = () => $('.kd-step-progress').outerWidth() / this.firstVisibleStep

  this.checkArrowStates = () => {
    this.$prev.removeClass('is-disabled')
    this.$next.removeClass('is-disabled')

    this.$prev.attr('tabindex', '')
    this.$next.attr('tabindex', '')

    if (!this.currentStep) {
      this.$prev.addClass('is-disabled')
      this.$prev.attr('tabindex', '-1')
    }

    if (this.isCurrentStepOutOfBounds()) {
      this.$next.addClass('is-disabled')
      this.$next.attr('tabindex', '-1')
    }
  }

  this.setArrowClicks = () => {
    $('.js-wizardNav_prev').on('click.stepProgress', evt => {
      if (this.currentStep)
        this.gotoPreviousStep()
    })

    $('.js-wizardNav_next').on('click.stepProgress', evt => {
      if (!this.isCurrentStepOutOfBounds())
        this.gotoNextStep()
    })
  }

  this.addStepClickEvent = $menuItem => {
    $('a', $menuItem).on('click.stepProgress', evt => {
      if ($menuItem.hasClass('is-disabled') || $menuItem.hasClass('is-active'))
        return

      this.wizard.showPageByIndex(this.steps.indexOf($menuItem))
    })
  }

  this.setCurrent = index => {
    this.currentStep = index

    const $menuItem = $(this.steps[index])

    $('.js-wizardNav_step').removeClass('is-active')

    $menuItem.removeClass('is-disabled')
    $menuItem.addClass('is-active')

    this.positionNav()
  }

  this.positionNav = () => {
    this.firstVisibleStep = this.getDeviceBreakpoint()
    this.resizeSteps()
    TweenLite.to(this.$stepHolder, 0, { left: this.getNavLeftPos() })
    this.checkArrowStates()
    this.setTabIndex()
  }

  this.setErrorStepByIndex = index => {
    const $step = this.steps[index]

    if($step)
      $step.addClass('is-error')
  }

  this.getDeviceBreakpoint = () => {
    return {
      xs: this.params.breakpoints.xs || 0,
      sm: this.params.breakpoints.sm || 1,
      md: this.params.breakpoints.mm || 2,
      lg: this.params.breakpoints.lm || 3,
    }[Kadenze.Layout.getDeviceSize()]
  }

  this.totalSteps = () => this.steps.length

  this.setActiveStepByIndex = index => this.setCurrent(index)

  this.isCurrentStepOutOfBounds = () => this.currentStep >= this.totalSteps() - 1

  this.gotoPreviousStep = () => this.gotoStep(this.currentStep - 1)

  this.gotoNextStep = () => this.gotoStep(this.currentStep + 1)

  this.gotoStep = idx => {
    this.wizard.showPageByIndex(idx)
    Kadenze.Layout.update()
  }

  (() => {
    this.buildMenu()
    $(window).resize(_.debounce(this.positionNav, 100))
    this.setArrowClicks()
  })()
}
